import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import ConfirmationModal from "../sub/modals/ConfirmationModal";
import Util from "../../util/Util";
import { updPatientAdmin } from "../../actions/patients/patients";
import { Alert, Col, Row } from "react-bootstrap";
import Roles from "../../enums/Roles";
import MenuButton from "../sub/bootstrap/MenuButton";
import TableToolbar from "../sub/bootstrap/TableToolbar";
import PopoverHelper from "../sub/bootstrap/PopoverHelper";
import SwitchToggle from "../sub/SwitchToggle";
import ComboBox from "../sub/ComboBox";

// Props
// client_typeFilter = "helper" | "prescriber"

class PatientClients extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      selectedClient: null,
      prescriber_id: "",
      prescriber_lead: this.props.patient
        ? this.props.patient.prescriber_lead
        : null,
      helper_id: "",
      helper_lead: this.props.patient ? this.props.patient.helper_lead : null,
    };
  }

  closeModal() {
    this.setState({ modal: null });
  }

  getSelectOptions(fieldNameIds) {
    const options = [];
    const clients = this.props.clients.filter(
      (c) =>
        c.client_type === this.props.client_typeFilter &&
        !this.props.patient[fieldNameIds].includes(c._id),
    );
    for (const c of clients) {
      options.push({
        _id: c._id,
        name: Util.formatFullName(c.first_name, c.name),
      });
    }
    return options;
  }

  onChange(field, value, clientId) {
    const updatePatientLead = (field) => {
      let clonedPatient = Util.shallowClone(this.props.patient);
      clonedPatient[field] = clientId;

      if (!value) clonedPatient[field] = null;

      const successCallback = (patient) => {
        this.setState({ [field]: patient[field] });
      };

      const patient = {
        _id: this.props.patient._id,
        [field]: clientId,
      };

      this.props.onUpdPatientAdmin(patient, successCallback);
    };

    if (field === "lead") {
      if (this.props.client_typeFilter === "helper")
        updatePatientLead("helper_lead");
      else if (this.props.client_typeFilter === "prescriber")
        updatePatientLead("prescriber_lead");
    } else {
      this.setState({ [field]: value });

      if (field === "helper_id" && !this.props.patient.helpers_ids.length) {
        this.setState({ helper_lead: value });
      } else if (
        field === "prescriber_id" &&
        !this.props.patient.prescribers_ids.length
      ) {
        this.setState({ prescriber_lead: value });
      }
    }
  }

  openConfirmModal(patient, clientId) {
    const modalContent =
      this.props.client_typeFilter === "helper"
        ? "Confirm.Helper.Removal"
        : "Confirm.Prescriber.Removal";

    this.setState({
      modal: (
        <ConfirmationModal
          mandatoryConfirmation
          title={<FormattedMessage id="Warning" />}
          onAccept={() => this.removeClient(patient, clientId)}
          onDecline={() => this.closeModal()}
        >
          <FormattedMessage id={modalContent} />
        </ConfirmationModal>
      ),
    });
  }

  addClient(clientId) {
    if (!clientId || Util.emptyString(clientId)) return;

    const addClientToPatient = (fieldNameIds, fieldNameLead) => {
      let clonedPatient = Util.shallowClone(this.props.patient);

      if (!clonedPatient[fieldNameIds]) clonedPatient[fieldNameIds] = [];

      clonedPatient[fieldNameIds].push(clientId);

      if (clonedPatient[fieldNameIds].length === 1) {
        clonedPatient[fieldNameLead] = this.state[fieldNameLead];
      }

      return clonedPatient;
    };

    const successCallback = (patient) =>
      this.setState({
        modal: null,
        prescriber_lead: patient.prescriber_lead,
        helper_lead: patient.helper_lead,
        selectedClient: null,
      });

    let clonedPatient = {};
    let clientsData = {};

    if (this.props.client_typeFilter === "helper") {
      clonedPatient = addClientToPatient("helpers_ids", "helper_lead");
      clientsData = {
        _id: this.props.patient._id,
        helpers_ids: clonedPatient.helpers_ids,
      };
    } else if (this.props.client_typeFilter === "prescriber") {
      clonedPatient = addClientToPatient("prescribers_ids", "prescriber_lead");
      clientsData = {
        _id: this.props.patient._id,
        prescribers_ids: clonedPatient.prescribers_ids,
      };
    }

    this.props.onUpdPatientAdmin(clientsData, successCallback);
  }

  removeClient(patient, clientId) {
    const removeClientFromPatient = (fieldNameIds, fieldNameLead) => {
      const clonedPatient = Util.shallowClone(patient);
      clonedPatient[fieldNameIds] = clonedPatient[fieldNameIds].filter(
        (id) => id !== clientId,
      );
      if (clonedPatient[fieldNameLead] === clientId) {
        clonedPatient[fieldNameLead] = null;
      }
      return clonedPatient;
    };

    const successCallback = (patient) => {
      if (this.props.client_typeFilter === "helper") {
        this.setState({ helper_lead: patient.helper_lead, modal: null });
      } else if (this.props.client_typeFilter === "prescriber") {
        this.setState({
          prescriber_lead: patient.prescriber_lead,
          modal: null,
        });
      }
    };

    let clonedPatient = {};
    let clientsData = {};

    if (this.props.client_typeFilter === "helper") {
      clonedPatient = removeClientFromPatient("helpers_ids", "helper_lead");
      clientsData = {
        _id: this.props.patient._id,
        helpers_ids: clonedPatient.helpers_ids,
        helper_lead: clonedPatient.helper_lead,
      };
    } else if (this.props.client_typeFilter === "prescriber") {
      clonedPatient = removeClientFromPatient(
        "prescribers_ids",
        "prescriber_lead",
      );
      clientsData = {
        _id: this.props.patient._id,
        prescribers_ids: clonedPatient.prescribers_ids,
        prescriber_lead: clonedPatient.prescriber_lead,
      };
    }

    this.props.onUpdPatientAdmin(clientsData, successCallback);
  }

  render() {
    const { user, patient, clients } = this.props;

    if (!patient) return null;

    const canManage =
      !user.supervisor_id ||
      (user.supervisor_id && user.has_write_permission);

    let fieldNameIds = "";
    let fieldNameLead = "";
    let alertInfoMessageId = "";
    let selectDefaultLabelId = "";
    let emptyMessage = <FormattedMessage id="Empty.Helpers" />;

    if (this.props.client_typeFilter === "helper") {
      fieldNameIds = "helpers_ids";
      fieldNameLead = "helper_lead";
      alertInfoMessageId = "Assign.Helper";
      selectDefaultLabelId = "Select.Helper";
    } else if (this.props.client_typeFilter === "prescriber") {
      fieldNameIds = "prescribers_ids";
      fieldNameLead = "prescriber_lead";
      alertInfoMessageId = "Assign.Prescriber";
      selectDefaultLabelId = "Select.Prescriber";
      emptyMessage = <FormattedMessage id="Empty.Prescribers" />;
    }

    let clientsAssignmentsNodes = patient[fieldNameIds].map((id) => {
      let client = clients.find((p) => p._id === id);
      if (!client) {
        return null;
      }
      return (
        <tr key={"client-" + client._id}>
          <td className="align-middle">
            <span
              className={
                this.state.helper_lead === client._id ||
                this.state.prescriber_lead === client._id
                  ? "fw-bold"
                  : ""
              }
            >
              {Util.formatFullName(client.first_name, client.name)}
            </span>
            {this.state.helper_lead === client._id && (
              <PopoverHelper>
                <FormattedMessage id="Hint.Main.Helper" />
              </PopoverHelper>
            )}
            {this.state.prescriber_lead === client._id && (
              <PopoverHelper>
                <FormattedMessage id="Hint.Main.Prescriber" />
              </PopoverHelper>
            )}
          </td>
          <td className="align-middle col-3">
            <SwitchToggle
              id={"lead-switch" + client._id}
              onChange={(e) => {
                canManage && this.onChange("lead", e.checked, client._id);
              }}
              checked={this.state[fieldNameLead] === client._id}
              disabled={
                !canManage ||
                this.state.helper_lead === client._id ||
                this.state.prescriber_lead === client._id
              }
            />
          </td>
          {canManage &&
            (user.role === Roles.ADMIN || user.role === Roles.SALES_REP) && (
              <td className="align-middle col-1  text-center">
                <MenuButton
                  icon="trash"
                  className="me-2"
                  hover={<FormattedMessage id="Delete" />}
                  onClick={(e) => this.openConfirmModal(patient, client._id)}
                  disabled={
                    patient[fieldNameIds].length > 1
                      ? this.state.helper_lead === client._id ||
                        this.state.prescriber_lead === client._id
                      : false
                  }
                />
              </td>
            )}
        </tr>
      );
    });

    return (
      <React.Fragment>
        {canManage && user.role !== Roles.CLIENT && (
          <TableToolbar>
            <Row className="align-items-center">
              <Col md={1} className="text-end col-auto">
                <PopoverHelper>
                  <FormattedMessage id={alertInfoMessageId} />
                </PopoverHelper>
              </Col>
              <Col md={9}>
                <ComboBox
                  isValidNewOption={() => false}
                  onChange={(option) =>
                    this.setState({ selectedClient: option })
                  }
                  options={this.getSelectOptions(fieldNameIds)}
                  placeholder={<FormattedMessage id={selectDefaultLabelId} />}
                  defaultOption={this.state.selectedClient}
                />
              </Col>
              <Col className="text-end">
                <MenuButton
                  icon="plus-circle"
                  onClick={() => this.addClient(this.state.selectedClient)}
                  disabled={!this.state.selectedClient}
                >
                  <FormattedMessage id="Assign" />
                </MenuButton>
              </Col>
            </Row>
          </TableToolbar>
        )}
        {patient &&
        patient[fieldNameIds] &&
        patient[fieldNameIds].length > 0 ? (
          <table className="table table-striped tablee4mad mt-3">
            <thead>
              <tr>
                <th scope="col" className="col">
                  <FormattedMessage id="Name" />
                </th>
                <th scope="col" className="align-middle col-3">
                  <FormattedMessage id="Lead" />
                </th>
                {canManage &&
                  (user.role === Roles.ADMIN ||
                    user.role === Roles.SALES_REP) && (
                    <th scope="col" className="align-middle  text-center col-1">
                      <FormattedMessage id="Actions" />
                    </th>
                  )}
              </tr>
            </thead>
            <tbody>{clientsAssignmentsNodes}</tbody>
          </table>
        ) : (
          <Alert variant="secondary" className="mt-3">
            {emptyMessage}
          </Alert>
        )}
        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    clients: state.clients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdPatientAdmin: (patient, successCallback) =>
      dispatch(updPatientAdmin(patient, successCallback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientClients);
